export const BankIdDialogContentHeader = ({
  label,
}: {
  label: string | null;
}) => (label ? <p className={"mb-2 font-bold text-2xl"}>{label}</p> : null);
